import { render, staticRenderFns } from "./EditFocus.vue?vue&type=template&id=00dd467e&scoped=true"
import script from "./EditFocus.vue?vue&type=script&lang=js"
export * from "./EditFocus.vue?vue&type=script&lang=js"
import style0 from "./EditFocus.vue?vue&type=style&index=0&id=00dd467e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd467e",
  null
  
)

export default component.exports